import useHost from "./host";

export default function useGATag() {
    const host = useHost();
    if (host === "scored.co" || host === "m.scored.co") return "G-XG15LF7HLC";
    if (host === "communities.win" || host === "m.communities.win") return "G-55ZERZ34S9";
    if (host === "patriots.win" || host === "m.patriots.win") return "G-GEQX0QL57C";
    return "1";
}

export function useUmamiTag() {
    const host = useHost();
    if (host === "scored.co" || host === "m.scored.co") return "073f6309-6390-42db-ab2b-af861b47dffa";
    if (host === "communities.win" || host === "m.communities.win") return "ac099d13-a9a6-425f-934f-f229b43295d3";
    if (host === "patriots.win" || host === "m.patriots.win") return "1f14815c-bc8c-4757-9fae-d9950c56ba97";
    return "";
}